import { isIOS as isIosPlatform } from 'react-device-detect';

const useIosPlatform: Function = (): boolean => {
  return isIosPlatform;
};

export default useIosPlatform;
